export default __webpack_public_path__ + "static/media/face_1_44.803eaa91.png";